/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type KillswitchMCPServer = {
  id: string;
  name: string;
  projectId: string;
  /**
   * The project's display name
   */
  projectName: string;
};

/** @internal */
export const KillswitchMCPServer$inboundSchema: z.ZodMiniType<
  KillswitchMCPServer,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    name: z.string(),
    project_id: z.string(),
    project_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "project_id": "projectId",
      "project_name": "projectName",
    });
  }),
);

export function killswitchMCPServerFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchMCPServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchMCPServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchMCPServer' from JSON`,
  );
}
